export const TermsAndConditions = () => {
  return <div>Terms And Conditions</div>;
};
